const initialState = null;
export const SAVE_LIST = 'SAVE_LIST';

export const saveLists = (error) => {
    return {
        type: SAVE_LIST,
        payload: error,
    };
};

export const listsReducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_LIST:
            return action.payload;
        default:
            return state;
    }
};
